import { Edit } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Column, Medication } from "src/api/types";
import { theme } from "src/assets/theme";
import { useMedicationsDrawer } from "src/context/drawers/MedicationsDrawerProvider/useMedicationsDrawer";
import StatusIndicator from "src/shared/StatusIndicator";
import MedicationStatusBadge from "./components/MedicationStatusBadge";

export const useColumns = (): Column<Medication>[] => {
  const { handleOpenUpdateMedication } = useMedicationsDrawer();

  return [
    {
      id: "medication_status",
      label: "",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => <MedicationStatusBadge medication={row} />,
    },
    {
      id: "edit",
      label: "Edit",
      minWidth: 80,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => (
        <IconButton onClick={() => handleOpenUpdateMedication(row)}>
          <Edit sx={{ color: theme.palette.secondary.main }} />
        </IconButton>
      ),
    },
    {
      id: "active",
      label: "Active",
      minWidth: 50,
      align: "center",
      orderable: false,
      format: (row) => row.active.toString(),
      render: (row) => {
        let active: boolean = row.active;

        if (!row.pharmacy.active) {
          active = false;
        }

        return <StatusIndicator status={active} />;
      },
    },
    {
      id: "id",
      label: "ID",
      minWidth: 60,
      align: "center",
      orderable: false,
      format: (row) => row.id.toString(),
      render: (row) => (
        <Link to={`${row.id}`}>
          <Typography>{row.id}</Typography>
        </Link>
      ),
    },
    {
      id: "name",
      label: "Name",
      minWidth: 200,
      align: "center",
      orderable: false,
      format: (row) => row.name,
      render: (row) => <Typography>{row.name}</Typography>,
    },
    {
      id: "display_name",
      label: "Display name",
      minWidth: 150,
      align: "center",
      orderable: false,
      format: (row) => {
        if (row.display_name == null) {
          return "N/A";
        }

        return row.display_name;
      },
      render: (row) => <Typography>{row.display_name}</Typography>,
    },

    {
      id: "dosage",
      label: "Dosage",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => {
        if (row.dosage == null) {
          return "N/A";
        }

        return row.dosage;
      },
      render: (row) => <Typography>{row.dosage}</Typography>,
    },
    {
      id: "strength",
      label: "Strength",
      minWidth: 200,
      align: "center",
      orderable: false,
      format: (row) => row.strength,
      render: (row) => <Typography>{row.strength}</Typography>,
    },
    {
      id: "form",
      label: "Form",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.form,
      render: (row) => (
        <Typography textTransform={"capitalize"}>{row.form}</Typography>
      ),
    },
    {
      id: "dispense_unit",
      label: "Dispense unit",
      align: "center",
      minWidth: 100,
      orderable: false,
      format: (row) => row.dispense_unit,
      render: (row) => (
        <Typography textTransform={"capitalize"}>
          {row.dispense_unit}
        </Typography>
      ),
    },
    {
      id: "dispense_quantity",
      label: "Dispense quantity",
      align: "center",
      minWidth: 150,
      orderable: false,
      format: (row) => row.dispense_quantity.toString(),
      render: (row) => <Typography>{row.dispense_quantity}</Typography>,
    },
    {
      id: "pharmacy",
      label: "Pharmacy",
      minWidth: 100,
      align: "center",
      orderable: false,
      format: (row) => row.pharmacy.name,
      render: (row) => <Typography>{row.pharmacy.name}</Typography>,
    },
    {
      id: "drug_id",
      label: "Drug ID",
      minWidth: 150,
      align: "center",
      orderable: false,
      format: (row) => row.drug_id,
      render: (row) => <Typography>{row.drug_id}</Typography>,
    },
  ];
};
